/**
 * Where "Not you? Log out" on the MFA challenge screens sends the user.
 *
 * A half-finished login (password accepted, second factor pending) lives in
 * the Auth0 session on auth.hotelinking.com, not in any app. The challenge
 * screen never named the account and had no way out, so someone who did not
 * know which account they had signed in with was stuck until they cleared
 * cookies. `/v2/logout` ends that session.
 *
 * `returnTo` is checked against the client's Allowed Logout URLs by EXACT
 * match, path included: `https://admin.hotelinking.com` is accepted and
 * `https://admin.hotelinking.com/login` is a 400 (verified 2026-10-09). So
 * these are bare origins, each already on its client's list, and each
 * redirects an anonymous visitor straight back to login.
 *
 * A client not listed here gets a bare `/v2/logout`. Do NOT fall back to
 * `client_id` alone: Auth0 then returns to the client's FIRST allowed logout
 * URL, which for Admin, Wifibot, Integrations and Accounting is
 * `http://localhost:3000`-ish. The GuestMaker iOS app is left out on purpose
 * too: its only allowed URLs are app schemes, and the browser this page runs
 * in has no way to open one.
 */

import { GUESTMAKER_WEB_CLIENT_ID } from "./guestmakerClients";

const CLIENT_LOGOUT_RETURN_MAP: Record<string, string> = {
  [GUESTMAKER_WEB_CLIENT_ID]: "https://guestmaker.ai",
  // Wifibot
  "8BRbe3Aqi76CJgYRi3TSdQasaM51MCrW": "https://wifibot.ai",
  // Hotelinking admin
  p3Izr9GxZ3S3xDO24T0JCf2U5WE7lKvW: "https://admin.hotelinking.com",
};

export function getClientLogoutUrl(
  clientId: string | undefined | null
): string {
  const returnTo = clientId ? CLIENT_LOGOUT_RETURN_MAP[clientId] : undefined;
  if (!clientId || !returnTo) return "/v2/logout";

  const params = new URLSearchParams({ client_id: clientId, returnTo });
  return `/v2/logout?${params.toString()}`;
}
